import { createContext } from 'react';

export const CurrentItemContext = createContext(null);
export const CurrentItemDispatchContext = createContext(null);